var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_907_12549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 5.05461C5.33398 5.76185 5.61494 6.44013 6.11503 6.94022C6.61513 7.44032 7.29341 7.72127 8.00065 7.72127C8.7079 7.72127 9.38617 7.44032 9.88627 6.94022C10.3864 6.44013 10.6673 5.76185 10.6673 5.05461C10.6673 4.34736 10.3864 3.66908 9.88627 3.16899C9.38617 2.66889 8.7079 2.38794 8.00065 2.38794C7.29341 2.38794 6.61513 2.66889 6.11503 3.16899C5.61494 3.66908 5.33398 4.34736 5.33398 5.05461Z",
    fill: "#FBA12B",
    stroke: "#FBA12B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 13.6121V12.4202C3.5 11.7879 3.81607 11.1816 4.37868 10.7346C4.94129 10.2875 5.70435 10.0364 6.5 10.0364H9.5C10.2956 10.0364 11.0587 10.2875 11.6213 10.7346C12.1839 11.1816 12.5 11.7879 12.5 12.4202V13.6121",
    fill: "#FBA12B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 13.6121V12.4202C3.5 11.7879 3.81607 11.1816 4.37868 10.7346C4.94129 10.2875 5.70435 10.0364 6.5 10.0364H9.5C10.2956 10.0364 11.0587 10.2875 11.6213 10.7346C12.1839 11.1816 12.5 11.7879 12.5 12.4202V13.6121H3.5Z",
    stroke: "#FBA12B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_907_12549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonal);
export default __webpack_public_path__ + "static/media/personal.25c2d332245a9c0dafe7470dc63fe700.svg";
export { ForwardRef as ReactComponent };